(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["articles-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const rail = document.querySelector('.articles-grid__rail');
    const dots = document.querySelectorAll('.articles-grid__dot');

    if (rail && dots.length > 0) {
      const updateActiveDot = () => {
        const scrollLeft = rail.scrollLeft;
        const maxScrollLeft = rail.scrollWidth - rail.clientWidth;

        let activeIndex;
        if (scrollLeft < 10) {
          activeIndex = 0;
        } else if (scrollLeft >= maxScrollLeft - 10) {
          activeIndex = dots.length - 1;
        } else {
          const cards = rail.querySelectorAll('.articles-grid__card');
          if (cards.length === 0) return;

          const railRect = rail.getBoundingClientRect();
          const railCenter = railRect.left + railRect.width / 2;

          let minDistance = Infinity;
          activeIndex = 0;

          cards.forEach((card, index) => {
            const cardRect = card.getBoundingClientRect();
            const cardCenter = cardRect.left + cardRect.width / 2;
            const distance = Math.abs(cardCenter - railCenter);
            if (distance < minDistance) {
              minDistance = distance;
              activeIndex = index;
            }
          });
        }

        dots.forEach((dot, index) => {
          if (index === activeIndex) {
            dot.classList.add('articles-grid__dot--active');
          } else {
            dot.classList.remove('articles-grid__dot--active');
          }
        });
      };

      rail.addEventListener('scroll', updateActiveDot, { passive: true });

      dots.forEach((dot, index) => {
        dot.style.cursor = 'pointer';
        dot.addEventListener('click', () => {
          const card = rail.querySelector('.articles-grid__card');
          if (!card) return;
          const cardWidth = card.offsetWidth;
          const gap = parseInt(window.getComputedStyle(rail).gap) || 44;
          const stepWidth = cardWidth + gap;
          rail.scrollTo({
            left: index * stepWidth,
            behavior: 'smooth',
          });
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog"]) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-articles-listing]');

    sections.forEach((root) => {
      const button = root.querySelector('[data-view-more]');
      const hiddenCards = Array.from(root.querySelectorAll('.articles-card--is-hidden'));
      if (!button || hiddenCards.length === 0) return;

      button.addEventListener('click', () => {
        hiddenCards.forEach((card) => {
          card.hidden = false;
          card.classList.remove('articles-card--is-hidden');
        });
        button.hidden = true;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var header = document.querySelector('.site-header');
    if (!header) return;

    var menuButton = header.querySelector('.site-header__menu');
    if (!menuButton) return;

    var toggleMenu = function (open) {
      var isOpen = typeof open === 'boolean' ? open : !header.classList.contains('site-header--menu-open');

      // Find the Shopify section wrapper that wraps the header
      var sectionEl = header.closest('[id^="shopify-section-"]') || header.parentElement;

      if (isOpen) {
        // 1. Pin the wrapper height BEFORE the header goes fixed, so page content doesn't jump
        if (sectionEl) {
          sectionEl.style.minHeight = sectionEl.getBoundingClientRect().height + 'px';
        }
        // 2. Compensate for scrollbar disappearing (tablet range)
        var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
      } else {
        // Release the pinned height
        if (sectionEl) {
          sectionEl.style.minHeight = '';
        }
        document.documentElement.style.setProperty('--scrollbar-width', '0px');
      }

      header.classList.toggle('site-header--menu-open', isOpen);
      document.body.classList.toggle('no-scroll', isOpen);
      document.documentElement.classList.toggle('no-scroll', isOpen);
      menuButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      menuButton.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
    };

    menuButton.addEventListener('click', function () {
      toggleMenu();
    });

    // Close mobile menu overlay on link click (for hashes and smooth navigation)
    var navLinks = header.querySelectorAll('.site-header__nav a');
    navLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        if (header.classList.contains('site-header--menu-open')) {
          toggleMenu(false);
        }
      });
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 1180 && header.classList.contains('site-header--menu-open')) {
        toggleMenu(false);
      }
    });

    // Mobile dropdown toggling
    var caretButtons = header.querySelectorAll('.site-header__dropdown-caret-btn');
    caretButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var wrapper = btn.closest('.site-header__dropdown-wrapper');
        if (wrapper) {
          var isExpanded = wrapper.classList.toggle('site-header__dropdown-wrapper--open');
          btn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        }
      });
    });

    // Highlight active link based on URL/hash
    var highlightActiveLinks = function () {
      var currentPath = window.location.pathname;
      var currentHash = window.location.hash;

      var allLinks = header.querySelectorAll('.site-header__nav a');
      allLinks.forEach(function (link) {
        var linkPath = link.getAttribute('href');
        if (!linkPath) return;

        // Remove active classes first
        link.classList.remove('site-header__nav-link--active');
        link.classList.remove('site-header__sub-link--active');

        // Split path and hash
        var parts = linkPath.split('#');
        var path = parts[0];
        var hash = parts[1] ? '#' + parts[1] : '';

        if (path === currentPath) {
          if (link.closest('.site-header__dropdown-menu')) {
            // Dropdown sub-link: highlight with background block if hash matches
            // Default to 'mission' (Medication) if no hash is present in browser URL
            var activeHash = currentHash || '#mission';
            if (hash === activeHash) {
              link.classList.add('site-header__sub-link--active');
            }
          } else {
            // Top-level link: always underline if it matches the current path
            link.classList.add('site-header__nav-link--active');
          }
        }
      });
    };

    // Listen to hash and URL updates
    highlightActiveLinks();
    window.addEventListener('hashchange', highlightActiveLinks);
    window.addEventListener('popstate', highlightActiveLinks);

    // Watch for history.replaceState (used by tab script)
    var wrapHistory = function (type) {
      var orig = history[type];
      return function () {
        var rv = orig.apply(this, arguments);
        var e = new Event(type);
        e.arguments = arguments;
        window.dispatchEvent(e);
        return rv;
      };
    };
    if (typeof history !== 'undefined' && history.replaceState) {
      // Force dev server sync
      history.replaceState = wrapHistory('replaceState');
      window.addEventListener('replaceState', highlightActiveLinks);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-v2-expertise"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.home-v2-expertise').forEach((root) => {
    // Only set up and run the carousel/infinite loop logic on mobile viewports
    if (window.innerWidth >= 768) return;

    const container = root.querySelector('.home-v2-expertise__container');
    const dots = root.querySelectorAll('.home-v2-expertise__dot');
    const realItems = Array.from(container.querySelectorAll('.home-v2-expertise__item'));
    if (!container || dots.length === 0 || realItems.length === 0) return;

    const totalReal = realItems.length;

    // ── Infinite clone setup ──────────────────────────────────────────────────
    // Prepend a clone of the LAST real slide, append a clone of the FIRST.
    // Layout: [lastClone | slide0 | slide1 | ... | slideN | firstClone]
    const firstClone = realItems[0].cloneNode(true);
    const lastClone  = realItems[totalReal - 1].cloneNode(true);
    firstClone.setAttribute('aria-hidden', 'true');
    lastClone.setAttribute('aria-hidden', 'true');
    firstClone.classList.add('home-v2-expertise__item--clone');
    lastClone.classList.add('home-v2-expertise__item--clone');
    container.appendChild(firstClone);
    container.prepend(lastClone);

    // Cache slide width (updated on resize)
    let slideWidth = realItems[0].getBoundingClientRect().width || container.clientWidth || 375;
    window.addEventListener('resize', () => {
      slideWidth = realItems[0].getBoundingClientRect().width || container.clientWidth || 375;
      // Re-position to current real slide without animation after resize
      container.scrollLeft = (currentRealIndex + 1) * slideWidth;
    }, { passive: true });

    // Start at the first real slide (index 1 in the cloned layout)
    let currentRealIndex = 0; // 0-based index of real slides
    container.scrollLeft = slideWidth; // skip the prepended lastClone

    // ── Helpers ───────────────────────────────────────────────────────────────
    const updateDots = (realIdx) => {
      dots.forEach((dot, idx) => {
        dot.classList.toggle('home-v2-expertise__dot--active', idx === realIdx);
      });
    };

    // Jump instantly (no animation) to the real equivalent when on a clone
    const checkAndLoop = () => {
      const virtualIndex = Math.round(container.scrollLeft / slideWidth);
      if (virtualIndex === 0) {
        container.style.scrollSnapType = 'none';
        container.scrollLeft = totalReal * slideWidth;
        currentRealIndex = totalReal - 1;
        updateDots(currentRealIndex);
        
        // Restore scroll snap after the scroll position update settles
        setTimeout(() => {
          container.style.scrollSnapType = 'x mandatory';
        }, 50);
      } else if (virtualIndex === totalReal + 1) {
        container.style.scrollSnapType = 'none';
        container.scrollLeft = slideWidth;
        currentRealIndex = 0;
        updateDots(currentRealIndex);
        
        setTimeout(() => {
          container.style.scrollSnapType = 'x mandatory';
        }, 50);
      } else {
        currentRealIndex = virtualIndex - 1;
        updateDots(currentRealIndex);
      }
    };

    // Smooth scroll to a virtual position (1-based: 1 = first real slide)
    let transitionTimeoutId = null;
    const scrollToVirtual = (virtualIndex) => {
      isProgrammaticScroll = true;
      container.style.scrollSnapType = 'none';
      container.scrollTo({ left: virtualIndex * slideWidth, behavior: 'smooth' });
      
      clearTimeout(transitionTimeoutId);
      transitionTimeoutId = setTimeout(() => {
        checkAndLoop(); // handle landing on a ghost clone
        container.style.scrollSnapType = 'x mandatory';
        isProgrammaticScroll = false;
      }, 650);
    };

    // Scroll to a real slide index (0-based), going in a direction that preserves infinite flow
    const scrollToReal = (realIdx) => {
      // Normalise to 0..totalReal-1
      const clamped = ((realIdx % totalReal) + totalReal) % totalReal;
      scrollToVirtual(clamped + 1); // virtual = real + 1 (because of prepended clone)
    };

    // ── Auto-scroll ───────────────────────────────────────────────────────────
    let intervalId = null;
    let isProgrammaticScroll = false;
    let scrollTimeout = null;

    const startAutoScroll = () => {
      stopAutoScroll();
      intervalId = setInterval(() => {
        if (window.innerWidth >= 768) return;
        // Advance forward; wrap via clone then instant-jump
        const nextVirtual = Math.round(container.scrollLeft / slideWidth) + 1;
        scrollToVirtual(nextVirtual);
      }, 6000);
    };

    const stopAutoScroll = () => {
      if (intervalId) { clearInterval(intervalId); intervalId = null; }
    };

    // ── Scroll listener ───────────────────────────────────────────────────────
    let scrollEndTimeout = null;
    container.addEventListener('scroll', () => {
      const virtualIndex = Math.round(container.scrollLeft / slideWidth);
      const realIdx = ((virtualIndex - 1) % totalReal + totalReal) % totalReal;
      updateDots(realIdx);

      if (!isProgrammaticScroll) {
        stopAutoScroll();
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => startAutoScroll(), 3000);

        // Check for wrapping when manual scrolling settles (de-bounce)
        clearTimeout(scrollEndTimeout);
        scrollEndTimeout = setTimeout(() => {
          checkAndLoop();
        }, 150);
      }
    });

    // ── Touch swipe (10 px threshold, infinite wrap) ──────────────────────────
    let startX = 0;
    let isTouching = false;

    container.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isTouching = true;
      isProgrammaticScroll = false;
      
      // Cancel any pending programmatic scroll transitions
      clearTimeout(transitionTimeoutId);
      
      container.style.scrollSnapType = 'none'; // free drag
      stopAutoScroll();
      clearTimeout(scrollTimeout);
    }, { passive: true });

    const handleTouchEnd = (e) => {
      if (!isTouching) return;
      isTouching = false;

      const deltaX = startX - e.changedTouches[0].clientX;
      const currentVirtual = Math.round(container.scrollLeft / slideWidth);
      let targetVirtual = currentVirtual;

      if (Math.abs(deltaX) > 10) {
        targetVirtual = deltaX > 0 ? currentVirtual + 1 : currentVirtual - 1;
      }

      scrollToVirtual(targetVirtual);

      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => startAutoScroll(), 4000);
    };

    container.addEventListener('touchend',   handleTouchEnd, { passive: true });
    container.addEventListener('touchcancel', handleTouchEnd, { passive: true });

    // ── Dot click navigation ──────────────────────────────────────────────────
    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const realIdx = parseInt(dot.getAttribute('data-index'), 10);
        stopAutoScroll();
        scrollToReal(realIdx);
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => startAutoScroll(), 5000);
      });
    });

    // ── Caret click navigation ────────────────────────────────────────────────
    container.querySelectorAll('.home-v2-expertise__caret-wrapper').forEach((caret) => {
      caret.setAttribute('role', 'button');
      caret.setAttribute('tabindex', '0');
      caret.style.cursor = 'pointer';

      caret.addEventListener('click', (e) => {
        e.stopPropagation();
        stopAutoScroll();
        const nextVirtual = Math.round(container.scrollLeft / slideWidth) + 1;
        scrollToVirtual(nextVirtual);
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => startAutoScroll(), 5000);
      });
    });

    // ── Init ──────────────────────────────────────────────────────────────────
    updateDots(0);
    // startAutoScroll(); // Temporarily disabled for manual swiping/looping testing
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works-team"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const rail = document.querySelector('.how-it-works-team__rail');
    const dots = document.querySelectorAll('.how-it-works-team__dot');

    if (rail && dots.length > 0) {
      const updateActiveDot = () => {
        const scrollLeft = rail.scrollLeft;
        const maxScrollLeft = rail.scrollWidth - rail.clientWidth;

        let activeIndex;
        if (scrollLeft < 10) {
          activeIndex = 0;
        } else if (scrollLeft >= maxScrollLeft - 10) {
          activeIndex = dots.length - 1;
        } else {
          const cards = rail.querySelectorAll('.how-it-works-team__card');
          if (cards.length === 0) return;

          const railRect = rail.getBoundingClientRect();
          const railCenter = railRect.left + railRect.width / 2;

          let minDistance = Infinity;
          activeIndex = 0;

          cards.forEach((card, index) => {
            const cardRect = card.getBoundingClientRect();
            const cardCenter = cardRect.left + cardRect.width / 2;
            const distance = Math.abs(cardCenter - railCenter);
            if (distance < minDistance) {
              minDistance = distance;
              activeIndex = index;
            }
          });
        }

        dots.forEach((dot, index) => {
          if (index === activeIndex) {
            dot.classList.add('active');
          } else {
            dot.classList.remove('active');
          }
        });
      };

      rail.addEventListener('scroll', updateActiveDot, { passive: true });

      // Click behavior
      dots.forEach((dot, index) => {
        dot.style.cursor = 'pointer';
        dot.addEventListener('click', () => {
          const card = rail.querySelector('.how-it-works-team__card');
          if (!card) return;
          const cardWidth = card.offsetWidth;
          const gap = parseInt(window.getComputedStyle(rail).gap) || 22;
          const stepWidth = cardWidth + gap;
          rail.scrollTo({
            left: index * stepWidth,
            behavior: 'smooth',
          });
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mission-overview"] && !Shopify.designMode) return;
  try {
    
  const initMissionOverviewTabs = () => {
    const tabButtons = document.querySelectorAll('[data-mission-tab]');
    if (tabButtons.length === 0) return;

    const tabPanels = document.querySelectorAll('[data-mission-panel]');
    const missionSections = document.querySelectorAll('.mission-eligibility, .mission-suitability, .mission-faqs');
    const articleSections = document.querySelectorAll('[data-mnt-articles-grid]');
    const tabTargets = ['mission', 'nutrition', 'training'];

    const syncArticleSections = (target) => {
      articleSections.forEach((section) => {
        const filter = section.getAttribute('data-mnt-articles-filter');
        const isVisible = filter === 'all' || filter === target || (target === 'mission' && filter === 'medication');
        section.hidden = !isVisible;
      });
    };

    const setActiveTab = (target, options = {}) => {
      if (!tabTargets.includes(target)) {
        return;
      }

      tabButtons.forEach((button) => {
        const isActive = button.getAttribute('data-mission-tab') === target;
        button.classList.toggle('mission-overview__tab--active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        button.tabIndex = isActive ? 0 : -1;
      });

      tabPanels.forEach((panel) => {
        const isActive = panel.getAttribute('data-mission-panel') === target;
        panel.hidden = !isActive;
        panel.classList.toggle('mission-overview__panel--active', isActive);
      });

      const showMissionSections = target === 'mission';

      missionSections.forEach((section) => {
        section.hidden = !showMissionSections;
      });

      syncArticleSections(target);

      // Hash updates are no longer needed for separate page URLs
    };

    const resolveTabFromPathOrHash = () => {
      const hash = window.location.hash.replace('#', '');
      const path = window.location.pathname;

      if (path.includes('nutrition') || hash === 'nutrition' || hash === 'mission-overview-panel-nutrition') {
        return 'nutrition';
      }
      if (path.includes('training') || hash === 'training' || hash === 'mission-overview-panel-training') {
        return 'training';
      }
      if (path.includes('medication') || path.includes('what-is-mnt') || hash === 'mission' || hash === 'mission-overview-panel-mission') {
        return 'mission';
      }

      if (tabTargets.includes(hash)) {
        return hash;
      }

      return null;
    };

    const activeMissionTab = document.querySelector('[data-mission-tab].mission-overview__tab--active');
    const initialTarget = activeMissionTab ? activeMissionTab.getAttribute('data-mission-tab') : 'mission';
    setActiveTab(resolveTabFromPathOrHash() || initialTarget, { updateHash: false });

    window.addEventListener('hashchange', () => {
      const target = resolveTabFromPathOrHash();

      if (target) {
        setActiveTab(target, { updateHash: false });
      }
    });

    // Also listen to replaceState updates from navigation
    window.addEventListener('replaceState', () => {
      const target = resolveTabFromPathOrHash();
      if (target) {
        setActiveTab(target, { updateHash: false });
      }
    });
  };

  if (document.readyState === 'loading') {
    // Force overview dev sync
    document.addEventListener('DOMContentLoaded', initMissionOverviewTabs);
  } else {
    initMissionOverviewTabs();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["results-estimate"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-results-estimate]').forEach((root) => {
    const range = root.querySelector('[data-weight-range]');
    const thumb = root.querySelector('[data-slider-thumb]');
    const active = root.querySelector('.results-estimate__active');
    const weightValue = root.querySelector('[data-weight-value]');
    const lossValue = root.querySelector('[data-loss-value]');
    const lossSubtext = root.querySelector('[data-loss-subtext]');
    const unitButtons = Array.from(root.querySelectorAll('[data-unit-toggle]'));

    const state = {
      unit: 'kg',
    };

    const getLossKg = (kg) => Math.round(kg * 0.16);

    const updateUI = () => {
      const min = Number(range.min);
      const max = Number(range.max);
      const value = Number(range.value);
      const progress = ((value - min) / (max - min)) * 100;

      active.style.width = `${progress}%`;
      thumb.style.left = `${progress}%`;

      const displayWeight = state.unit === 'kg' ? `${value}kg` : `${Math.round(value * 2.20462)}lbs`;
      weightValue.textContent = displayWeight;

      const lossKg = getLossKg(value);
      lossValue.textContent = state.unit === 'kg' ? `${lossKg} kg` : `${Math.round(lossKg * 2.20462)} lbs`;
      lossSubtext.textContent = 'body weight in 12 months';
    };

    range.addEventListener('input', updateUI);

    unitButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const nextUnit = button.dataset.unitToggle;
        if (state.unit === nextUnit) return;
        state.unit = nextUnit;

        unitButtons.forEach((item) => {
          const activeState = item === button;
          item.classList.toggle('is-active', activeState);
          item.setAttribute('aria-pressed', activeState ? 'true' : 'false');
        });

        updateUI();
      });
    });

    updateUI();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["results-testimonials"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const rail = document.querySelector('.testimonials-carousel__rail');
    const dots = document.querySelectorAll('.testimonials-carousel__dot');
    
    if (rail && dots.length > 0) {
      const updateActiveDot = () => {
        const scrollLeft = rail.scrollLeft;
        const maxScrollLeft = rail.scrollWidth - rail.clientWidth;
        
        let activeIndex;
        if (scrollLeft < 10) {
          activeIndex = 0;
        } else if (scrollLeft >= maxScrollLeft - 10) {
          activeIndex = dots.length - 1;
        } else {
          const cards = rail.querySelectorAll('.testimonials-carousel__card');
          if (cards.length === 0) return;
          
          const railRect = rail.getBoundingClientRect();
          const railCenter = railRect.left + railRect.width / 2;
          
          let minDistance = Infinity;
          activeIndex = 0;
          
          cards.forEach((card, index) => {
            const cardRect = card.getBoundingClientRect();
            const cardCenter = cardRect.left + cardRect.width / 2;
            const distance = Math.abs(cardCenter - railCenter);
            if (distance < minDistance) {
              minDistance = distance;
              activeIndex = index;
            }
          });
        }
        
        dots.forEach((dot, index) => {
          if (index === activeIndex) {
            dot.classList.add('active');
          } else {
            dot.classList.remove('active');
          }
        });
      };

      rail.addEventListener('scroll', updateActiveDot, { passive: true });

      dots.forEach((dot, index) => {
        dot.style.cursor = 'pointer';
        dot.addEventListener('click', () => {
          const card = rail.querySelector('.testimonials-carousel__card');
          if (!card) return;
          const cardWidth = card.offsetWidth;
          const gap = parseInt(window.getComputedStyle(rail).gap) || 24;
          const stepWidth = cardWidth + gap;
          rail.scrollTo({
            left: index * stepWidth,
            behavior: 'smooth'
          });
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const rail = document.querySelector('.testimonials-carousel__rail');
    const dots = document.querySelectorAll('.testimonials-carousel__dot');
    
    if (rail && dots.length > 0) {
      const updateActiveDot = () => {
        const scrollLeft = rail.scrollLeft;
        const maxScrollLeft = rail.scrollWidth - rail.clientWidth;
        
        let activeIndex;
        if (scrollLeft < 10) {
          activeIndex = 0;
        } else if (scrollLeft >= maxScrollLeft - 10) {
          activeIndex = dots.length - 1;
        } else {
          const cards = rail.querySelectorAll('.testimonials-carousel__card');
          if (cards.length === 0) return;
          
          const railRect = rail.getBoundingClientRect();
          const railCenter = railRect.left + railRect.width / 2;
          
          let minDistance = Infinity;
          activeIndex = 0;
          
          cards.forEach((card, index) => {
            const cardRect = card.getBoundingClientRect();
            const cardCenter = cardRect.left + cardRect.width / 2;
            const distance = Math.abs(cardCenter - railCenter);
            if (distance < minDistance) {
              minDistance = distance;
              activeIndex = index;
            }
          });
        }
        
        dots.forEach((dot, index) => {
          if (index === activeIndex) {
            dot.classList.add('active');
          } else {
            dot.classList.remove('active');
          }
        });
      };

      rail.addEventListener('scroll', updateActiveDot, { passive: true });

      dots.forEach((dot, index) => {
        dot.style.cursor = 'pointer';
        dot.addEventListener('click', () => {
          const card = rail.querySelector('.testimonials-carousel__card');
          if (!card) return;
          const cardWidth = card.offsetWidth;
          const gap = parseInt(window.getComputedStyle(rail).gap) || 24;
          const stepWidth = cardWidth + gap;
          rail.scrollTo({
            left: index * stepWidth,
            behavior: 'smooth'
          });
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
